import { useMutation, useQueryClient } from "react-query";
import { addLineOfBusiness } from "../../../../../actions/Utilities/LineOfBusiness";
import { toast } from "../../../../../components/toastNotification";
import { lineOfBusinessInfo } from "../types";

const useAddLineOfBusiness = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (newData: lineOfBusinessInfo) => 
    addLineOfBusiness([newData]),
    {
      onSuccess: (res: any) => {
        if (res === "Duplicate") {
          toast.fire("Saving Failed", "The data already exists!", "error");
        } else {
          queryClient.invalidateQueries(["GetLineOfBusiness"]);
          toast.fire(
            "Success",
            "Line of Business Added Successfully",
            "success"
          );
        }
      },
      onError: (error) => {
        toast.fire("Failed", "Failed to Add Line of Business", "error");
      },
    }
  );

  return mutate;
};
export default useAddLineOfBusiness;
